<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Generali" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Condizioni cliniche generali</label>
                            <span v-if="isReadOnly"> {{ jsonData.condizioneClinicaGenerale }}</span>
                            <b-form-select v-else v-model="jsonData.condizioneClinicaGenerale" :options="condizioneClinicaGeneraleOptions">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> -Seleziona un'opzione- </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Sensorio</label>
                            <span v-if="isReadOnly">{{ jsonData.sensorio }}</span>
                            <b-form-select v-else v-model="jsonData.sensorio" :options="sensorioOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Postura</label>
                            <span v-if="isReadOnly">{{ jsonData.postura }}</span>
                            <b-form-select v-else v-model="jsonData.postura" :options="posturaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Protesi</label>
                            <span v-if="isReadOnly">{{ jsonData.protesi }}</span>
                            <b-form-select v-else v-model="jsonData.protesi" :options="protesiOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Descrizione Protesi</label>
                            <span v-if="isReadOnly">{{ jsonData.protesiDescrizione }}</span>
                            <b-form-input v-else v-model="jsonData.protesiDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Peso(kg)</label>
                            <span v-if="isReadOnly">{{ jsonData.peso }}</span>
                            <b-form-input v-else v-model="jsonData.peso" :readonly="isReadOnly" type="number" step="0.01"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Altezza(cm)</label>
                            <span v-if="isReadOnly">{{ jsonData.altezza }}</span>
                            <b-form-input v-else v-model="jsonData.altezza" :readonly="isReadOnly" type="number" step="0.01"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Alvo</label>
                            <span v-if="isReadOnly">{{ jsonData.alvo }}</span>
                            <b-form-input v-else v-model="jsonData.alvo" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Diuresi</label>
                            <span v-if="isReadOnly">{{ jsonData.diuresi }}</span>
                            <b-form-input v-else v-model="jsonData.diuresi" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Alimentazione</label>
                            <span v-if="isReadOnly">{{ jsonData.alimentazione }}</span>
                            <b-form-input v-else v-model="jsonData.alimentazione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Stato nutrizionale</label>
                            <span v-if="isReadOnly">{{ jsonData.statoNutrizionale }}</span>
                            <b-form-select v-else v-model="jsonData.statoNutrizionale" :options="statoNutrizionaleOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Decubito</label>
                            <span v-if="isReadOnly">{{ jsonData.decubito }}</span>
                            <b-form-select v-else v-model="jsonData.decubito" :options="decubitoOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Visus</label>
                            <span v-if="isReadOnly">{{ jsonData.visus }}</span>
                            <b-form-select v-else v-model="jsonData.visus" :options="visusOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Bocca</label>
                            <span v-if="isReadOnly">{{ jsonData.bocca }}</span>
                            <b-form-select v-else v-model="jsonData.bocca" :options="boccaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Esame Neurologico</label>
                            <span v-if="isReadOnly">{{ jsonData.esameNeurologico }}</span>
                            <b-form-textarea v-else v-model="jsonData.esameNeurologico" :readonly="isReadOnly" max-rows="10" rows="5"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Ossa e Articolazioni</label>
                            <span v-if="isReadOnly">{{ jsonData.ossaArticolazioni }}</span>
                            <b-form-textarea v-else v-model="jsonData.ossaArticolazioni" :readonly="isReadOnly" max-rows="10" rows="5"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note</label>
                            <span v-if="isReadOnly">{{ jsonData.note }}</span>
                            <b-form-textarea v-else v-model="jsonData.note" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    condizioneClinicaGenerale: "",
                    sensorio: "",
                    postura: "",
                    protesi: "",
                    protesiDescrizione: "",
                    peso: "",
                    altezza: "",
                    alvo: "",
                    diuresi: "",
                    alimentazione: "",
                    statoNutrizionale: "",
                    decubito: "",
                    visus: "",
                    bocca: "",
                    note: "",
                    esameNeurologico: "",
                    ossaArticolazioni: "",
                };
            },
        },
    },
    data() {
        return {
            pathResourceSchedaEsameObiettivoGeneraleGenerali: "/rsaschedaesameobiettivogeneralegenerali",
            condizioneClinicaGeneraleOptions: [
                { text: "SCADUTE", value: "SCADUTE" },
                { text: "MEDIOCRI", value: "MEDIOCRI" },
                { text: "DISCRETE", value: "DISCRETE" },
                { text: "BUONE", value: "BUONE" },
            ],
            sensorioOptions: [
                { text: "INTEGRO", value: "INTEGRO" },
                { text: "SOPOROSO", value: "SOPOROSO" },
                { text: "OBNUBILATO", value: "OBNUBILATO" },
            ],
            posturaOptions: [
                { text: "INDIFFERENTE", value: "INDIFFERENTE" },
                { text: "OBBLIGATA LETTO", value: "OBBLIGATA LETTO" },
                { text: "LETTO/SEDIA", value: "LETTO/SEDIA" },
            ],
            statoNutrizionaleOptions: [
                { text: "ADEGUATO", value: "ADEGUATO" },
                { text: "ALTERATO PER ECCESSO", value: "ALTERATO PER ECCESSO" },
                { text: "ALTERATO PER DIFETTO", value: "ALTERATO PER DIFETTO" },
            ],
            protesiOptions: [
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
                { text: "NON DEFINITO", value: "NON DEFINITO" },
            ],
            decubitoOptions: [
                { text: "INDIFFERENTE", value: "INDIFFERENTE" },
                { text: "LETTO/SEDIA", value: "LETTO/SEDIA" },
                { text: "ALLETTATO", value: "ALLETTATO" },
            ],
            visusOptions: [
                { text: "NORMALE", value: "NORMALE" },
                { text: "RIDOTTO", value: "RIDOTTO" },
            ],
            boccaOptions: [
                { text: "NORMALE", value: "NORMALE" },
                { text: "EDENTULIA TOTALE (PROTESIZZATE O NON PROTESIZZATE)", value: "EDENTULIA TOTALE (PROTESIZZATE O NON PROTESIZZATE)" },
                { text: "EDENTULIA PARZIALE (PROTESIZZATE O NON PROTESIZZATE)", value: "EDENTULIA PARZIALE (PROTESIZZATE O NON PROTESIZZATE)" },
            ],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mixins: [UtilityMixin],

    methods: {
        loadGeneraliData() {
            let me = this;
            // console.log("idAccettazione LoadGeneraleData", me.idAccettazione);
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaEsameObiettivoGeneraleGenerali + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaEsameObiettivoGeneraleGeneraliSuccess, me.resultResponseSchedaEsameObiettivoGeneraleGeneraliError);
        },
        resultResponseSchedaEsameObiettivoGeneraleGeneraliSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            // console.log("ID del record Generali", me.jsonData.id);
        },
        resultResponseSchedaEsameObiettivoGeneraleGeneraliError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            } else {
                console.error("Errore nel caricamento dati della sezione GENERALI:", error);
            }
        },
        onSalvaSchedaEsameObiettivoGeneraleGenerali() {
            let me = this;
            me.jsonData.idAccettazione = me.idAccettazione;
            // console.log("Salvataggio Generali con dati:", JSON.stringify(me.jsonData));
            if (!me.jsonData.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonData.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaEsameObiettivoGeneraleGenerali, me.jsonData, me.saveSchedaEsameObiettivoGeneraleSuccessResponse, me.saveSchedaEsameObiettivoGeneraleErrorResponse);
        },
        saveSchedaEsameObiettivoGeneraleSuccessResponse() {},
        saveSchedaEsameObiettivoGeneraleErrorResponse() {
            console.error("Errore nel salvataggio di GENERALI:");
        },
    },
};
</script>
